import React from "react";
import PT from "prop-types";

import "./hamburger-menu.m.css";
import Close from "../other-icons/Close";
import HamburgerSearch from "../other-icons/HamburgerSearch";

export const HamburgerMenu = ({ onMenuToggle, isMegaMenuOpen, isMobileHamburger }) => (
  <button
    aria-label="Hamburger Menu"
    className="hamburger-menu"
    onClick={onMenuToggle}
    styleName={`hamburger ${isMegaMenuOpen ? "is-open" : ""}`}
  >
    {/* {[1, 2, 3].map((i) => (
      <span styleName="line" key={i} style={{ backgroundColor: !isMegaMenuOpen && isMobileHamburger && "white" }} />
    ))} */}

    {!isMegaMenuOpen ? (
      !isMobileHamburger && <HamburgerSearch color="black" width="30" height="20" />
    ) : (
      <Close color="black" width="10px" height="10px" />
    )}
  </button>
);

HamburgerMenu.propTypes = {
  onMenuToggle: PT.func,
  isMegaMenuOpen: PT.bool,
  isMobileHamburger: PT.bool
};

export default HamburgerMenu;
